import { useCallback } from 'react';
import { RbacPermissions } from '../../core/interfaces/user';
import useUserService from '../../auth/hooks/useUserService';
import useService from '../../injector/hooks/useService';
import { RbacService } from '../services/rbac.service';

const useHasPermission = () => {
  const _rbacService = useService(RbacService);
  const { user, rbacPermissions, isInternalUser  } = useUserService();

  const hasPermission = useCallback(
    (permission: RbacPermissions) => _rbacService.canTakeAction(permission),
    [rbacPermissions]
  );

  const isOwnerOrHasPermission = (permission: RbacPermissions) =>
    _rbacService.isRbacEnabled()
      ? _rbacService.canTakeAction(permission)
      : user.isOwner;


  return {
    isRbacEnabled: _rbacService.isRbacEnabled(),
    hasPermission,
    isInternalUserOrHasPermission: (permission: RbacPermissions) => isOwnerOrHasPermission(permission) || isInternalUser(),
    isOwnerOrHasPermission
  };
};

export default useHasPermission;
